/** An agent's Chrome extension link, on this dashboard's own address: it adds the agent to
    someone's extension (`/extension/{agent id}`, features/extension-link). Its web page is
    `clientAppLink` (shared/lib/client-app). */
export const extensionLink = (agentId: string) => `${window.location.origin}/extension/${agentId}`;

/** Our own apps: no account of the owner's to connect, every agent has them by its id. */
export const LINKED_TYPES = ["extension", "web"] as const;
